// eslint-disable-next-line no-unused-vars
import { createTheme } from '@mui/material/styles'

export const primary = {
    main: '#4A96E9',
    contrastText: '#fff',
}

export const secondary = {
    main: '#707070',
    contrastText: '#fff',
}

const theme = createTheme({
    palette: {
        primary,
        secondary,
    },
    typography: {
        fontFamily: 'Arial',
    },
    components: {
        // MuiButton: {
        //     styleOverrides: {
        //         root: {
        //             margin: '8px 8px',
        //         },
        //     },
        // },
    },
})

window.theme = theme

export default theme
